import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";

const Services = () => {
  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    return () => {};
  }, []);

  return (
    <div className="">
      <div className="page-container" id="services">
        <section className="">
          <div className="container">
            <div className="row">
              <section className="services-item1 anim1">
                <div className="box highlight">
                  <i className="fa fa-ad"></i>
                  <h3>Get Advertised</h3>
                  <p>
                    We will advertise you to people around and away from you.{" "}
                  </p>
                </div>
              </section>

              <section className="services-item2 anim2">
                <div className="box highlight">
                  <i className="fa fa-phone"></i>
                  <h3>Get Called</h3>
                  <p>
                    People those are looking for your services will give you a
                    call.
                  </p>
                </div>
              </section>
              <section className="services-item3 anim3">
                <div className="box highlight">
                  <i className="fa fa-users"></i>
                  <h3>Get Hired</h3>
                  <p>
                    You will get hired by people, around you and away from you.{" "}
                  </p>
                </div>
              </section>
            </div>
            <div className="signup-btn anim4">
              <NavLink to="/vendor-signup">
                <button className="primary-btn">Get Started</button>
              </NavLink>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Services;
